/**
 * GET (Getalbegrip) Module Seeds - DDD Canonical Location
 *
 * REK module migratie (17 mrt 2026): 3 bewerkingen families verwijderd.
 * - GET-HOOFDREKENEN → content splits naar REK-HANDIG-PLUS-MIN + REK-HANDIG-KEER
 * - GET-SCHATSTRATEGIE → REK-SCHATTEN
 * - GET-VOLGORDE-BEWERKING → REK-VOLGORDE
 *
 * See docs/SEED_REVIEW_CHECKLIST.md §H for migration process.
 */

// Import all GET family seed files (50 families — was 53, 3 migrated to REK)
// All 50/50 JSONs now in DDD location ✅
import GET_GROOT_POS from './GET-GROOT-POS.json'
import GET_GROOT_LEZEN from './GET-GROOT-LEZEN.json'
import GET_GROOT_VERGELIJK from './GET-GROOT-VERGELIJK.json'
import GET_GROOT_AFRONDEN from './GET-GROOT-AFRONDEN.json'
import GET_ROND_BASIS from './GET-ROND-BASIS.json'
import GET_GROOT_SCHATTEN from './GET-GROOT-SCHATTEN.json'
import GET_BREUK_BASIS from './GET-BREUK-BASIS.json'
import GET_BREUK_LEZEN from './GET-BREUK-LEZEN.json'
import GET_KOMMA_WAARDE from './GET-KOMMA-WAARDE.json'
import GET_BREUK_GEL_PLUS from './GET-BREUK-GEL-PLUS.json'
import GET_BREUK_GEL_MIN from './GET-BREUK-GEL-MIN.json'
import GET_VERGELIJK from './GET-VERGELIJK.json'
import GET_PROC_BASIS from './GET-PROC-BASIS.json'
import GET_BREUK_ONG_PLUS from './GET-BREUK-ONG-PLUS.json'
import GET_BREUK_MIN from './GET-BREUK-MIN.json'
import GET_BREUK_VEREENVOUDIG from './GET-BREUK-VEREENVOUDIG.json'
import GET_BREUK_KEER from './GET-BREUK-KEER.json'
import GET_PROC_VAN from './GET-PROC-VAN.json'
import GET_VERH_SCHAAL from './GET-VERH-SCHAAL.json'
import GET_PROC_NIEUW from './GET-PROC-NIEUW.json'
import GET_MACHT from './GET-MACHT.json'
import GET_BREUK_DEEL from './GET-BREUK-DEEL.json'
import GET_NEGATIEF from './GET-NEGATIEF.json'
import GET_WORTEL from './GET-WORTEL.json'
import GET_PROC_TERUG from './GET-PROC-TERUG.json'
import GET_WETENSCHAPPELIJK from './GET-WETENSCHAPPELIJK.json'
import GET_PROC_BTW from './GET-PROC-BTW.json'
import GET_KOMMA_LEZEN from './GET-KOMMA-LEZEN.json'
import GET_KOMMA_VERGELIJK from './GET-KOMMA-VERGELIJK.json'
import GET_BREUK_GETALLENLIJN from './GET-BREUK-GETALLENLIJN.json'
import GET_BREUK_UITBREIDEN from './GET-BREUK-UITBREIDEN.json'
import GET_KOMMA_PLUS from './GET-KOMMA-PLUS.json'
import GET_KOMMA_MIN from './GET-KOMMA-MIN.json'
import GET_KOMMA_GETALLENLIJN from './GET-KOMMA-GETALLENLIJN.json'
import GET_BREUK_GEMENGD from './GET-BREUK-GEMENGD.json'
import GET_KOMMA_KEER from './GET-KOMMA-KEER.json'
import GET_KOMMA_AFRONDEN from './GET-KOMMA-AFRONDEN.json'
import GET_KOMMA_DEEL from './GET-KOMMA-DEEL.json'
import GET_DEEL_KOMMA from './GET-DEEL-KOMMA.json'
import GET_VERH_BREUK_PROC_KOPPEL from './GET-VERH-BREUK-PROC-KOPPEL.json'
import GET_VERH_RECEPT from './GET-VERH-RECEPT.json'
import GET_VERH_SCHAAL_KAART from './GET-VERH-SCHAAL-KAART.json'
import GET_VERH_VERDELEN from './GET-VERH-VERDELEN.json'
import GET_PROC_TOENAME from './GET-PROC-TOENAME.json'
import GET_PROC_AFNAME from './GET-PROC-AFNAME.json'
import GET_NEGATIEF_PLUS from './GET-NEGATIEF-PLUS.json'
import GET_NEGATIEF_MIN from './GET-NEGATIEF-MIN.json'
import GET_MACHT_GRONDTAL from './GET-MACHT-GRONDTAL.json'
import GET_WETENSCHAP_REKEN from './GET-WETENSCHAP-REKEN.json'
import GET_PROC_SAMENGESTELD from './GET-PROC-SAMENGESTELD.json'

const GET_FAMILY_SEEDS = [
  {
    file: 'src/content/seeds/GET/GET-GROOT-POS.json',
    data: GET_GROOT_POS,
  },
  {
    file: 'src/content/seeds/GET/GET-GROOT-LEZEN.json',
    data: GET_GROOT_LEZEN,
  },
  {
    file: 'src/content/seeds/GET/GET-GROOT-VERGELIJK.json',
    data: GET_GROOT_VERGELIJK,
  },
  {
    file: 'src/content/seeds/GET/GET-GROOT-AFRONDEN.json',
    data: GET_GROOT_AFRONDEN,
  },
  {
    file: 'src/content/seeds/GET/GET-ROND-BASIS.json',
    data: GET_ROND_BASIS,
  },
  {
    file: 'src/content/seeds/GET/GET-GROOT-SCHATTEN.json',
    data: GET_GROOT_SCHATTEN,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-BASIS.json',
    data: GET_BREUK_BASIS,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-LEZEN.json',
    data: GET_BREUK_LEZEN,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-WAARDE.json',
    data: GET_KOMMA_WAARDE,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-GEL-PLUS.json',
    data: GET_BREUK_GEL_PLUS,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-GEL-MIN.json',
    data: GET_BREUK_GEL_MIN,
  },
  {
    file: 'src/content/seeds/GET/GET-VERGELIJK.json',
    data: GET_VERGELIJK,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-BASIS.json',
    data: GET_PROC_BASIS,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-ONG-PLUS.json',
    data: GET_BREUK_ONG_PLUS,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-MIN.json',
    data: GET_BREUK_MIN,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-VEREENVOUDIG.json',
    data: GET_BREUK_VEREENVOUDIG,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-KEER.json',
    data: GET_BREUK_KEER,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-VAN.json',
    data: GET_PROC_VAN,
  },
  {
    file: 'src/content/seeds/GET/GET-VERH-SCHAAL.json',
    data: GET_VERH_SCHAAL,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-NIEUW.json',
    data: GET_PROC_NIEUW,
  },
  {
    file: 'src/content/seeds/GET/GET-MACHT.json',
    data: GET_MACHT,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-DEEL.json',
    data: GET_BREUK_DEEL,
  },
  {
    file: 'src/content/seeds/GET/GET-NEGATIEF.json',
    data: GET_NEGATIEF,
  },
  {
    file: 'src/content/seeds/GET/GET-WORTEL.json',
    data: GET_WORTEL,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-TERUG.json',
    data: GET_PROC_TERUG,
  },
  {
    file: 'src/content/seeds/GET/GET-WETENSCHAPPELIJK.json',
    data: GET_WETENSCHAPPELIJK,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-BTW.json',
    data: GET_PROC_BTW,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-LEZEN.json',
    data: GET_KOMMA_LEZEN,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-VERGELIJK.json',
    data: GET_KOMMA_VERGELIJK,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-GETALLENLIJN.json',
    data: GET_BREUK_GETALLENLIJN,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-UITBREIDEN.json',
    data: GET_BREUK_UITBREIDEN,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-PLUS.json',
    data: GET_KOMMA_PLUS,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-MIN.json',
    data: GET_KOMMA_MIN,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-GETALLENLIJN.json',
    data: GET_KOMMA_GETALLENLIJN,
  },
  {
    file: 'src/content/seeds/GET/GET-BREUK-GEMENGD.json',
    data: GET_BREUK_GEMENGD,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-KEER.json',
    data: GET_KOMMA_KEER,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-AFRONDEN.json',
    data: GET_KOMMA_AFRONDEN,
  },
  {
    file: 'src/content/seeds/GET/GET-KOMMA-DEEL.json',
    data: GET_KOMMA_DEEL,
  },
  {
    file: 'src/content/seeds/GET/GET-DEEL-KOMMA.json',
    data: GET_DEEL_KOMMA,
  },
  {
    file: 'src/content/seeds/GET/GET-VERH-BREUK-PROC-KOPPEL.json',
    data: GET_VERH_BREUK_PROC_KOPPEL,
  },
  {
    file: 'src/content/seeds/GET/GET-VERH-RECEPT.json',
    data: GET_VERH_RECEPT,
  },
  {
    file: 'src/content/seeds/GET/GET-VERH-SCHAAL-KAART.json',
    data: GET_VERH_SCHAAL_KAART,
  },
  {
    file: 'src/content/seeds/GET/GET-VERH-VERDELEN.json',
    data: GET_VERH_VERDELEN,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-TOENAME.json',
    data: GET_PROC_TOENAME,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-AFNAME.json',
    data: GET_PROC_AFNAME,
  },
  {
    file: 'src/content/seeds/GET/GET-NEGATIEF-PLUS.json',
    data: GET_NEGATIEF_PLUS,
  },
  {
    file: 'src/content/seeds/GET/GET-NEGATIEF-MIN.json',
    data: GET_NEGATIEF_MIN,
  },
  {
    file: 'src/content/seeds/GET/GET-MACHT-GRONDTAL.json',
    data: GET_MACHT_GRONDTAL,
  },
  {
    file: 'src/content/seeds/GET/GET-WETENSCHAP-REKEN.json',
    data: GET_WETENSCHAP_REKEN,
  },
  {
    file: 'src/content/seeds/GET/GET-PROC-SAMENGESTELD.json',
    data: GET_PROC_SAMENGESTELD,
  },
] as const

const allQuestions = GET_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({
    ...question,
    __sourceFile: file,
  })),
)

// Export consolidated seed collection
export default {
  module: 'Getalbegrip',
  moduleCode: 'GET',
  version: '9.0-ddd-complete',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
